import React from 'react';
import { Box } from '@mui/material';

import { AngleField, DistanceField } from '@paragon/material';

import { updateShapeDetailsAndRegenerateTruss } from '../../../../../../store/actions/insertComponentDesignActions';
import { PiggybackShapeDetails as PiggybackShapeDetailsInterface } from '../../../../../../store/slices/applicationSlice';
import { useAppDispatch } from '../../../../../hooks';
import { LabeledBox } from '../../../properties/LabeledBox';
import { createExceedsMaxLengthErrorAction, exceedsMaxLength, minTrussLength } from './Length';

const textFieldSx = { m: 1, flex: 1 } as const;

interface Props {
  readonly shapeDetails: PiggybackShapeDetailsInterface;
}

export function PiggybackShapeDetails({ shapeDetails }: Props) {
  const dispatch = useAppDispatch();

  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <DistanceField
          label="Length"
          value={shapeDetails.span}
          min={minTrussLength}
          onSubmit={async (value) => {
            if (exceedsMaxLength(value)) {
              dispatch(createExceedsMaxLengthErrorAction());
              return;
            }

            await dispatch(updateShapeDetailsAndRegenerateTruss({ ...shapeDetails, span: value }));
          }}
          sx={textFieldSx}
        />
        <AngleField
          label="Slope"
          sx={textFieldSx}
          value={shapeDetails.slopeInDegrees}
          defaultDisplayFormat="slope"
          onSubmit={async (value) => {
            await dispatch(updateShapeDetailsAndRegenerateTruss({ ...shapeDetails, slopeInDegrees: value }));
          }}
        />
      </Box>

      <LabeledBox title="Piggyback Settings">
        <Box sx={{ display: 'flex', flexDirection: 'row', flex: 1, p: 1, justifyContent: 'space-around' }}>
          <DistanceField
            label="Purlin Thickness"
            value={shapeDetails.piggybackSettings.purlinThickness}
            min={0}
            onSubmit={async (purlinThickness) => {
              await dispatch(
                updateShapeDetailsAndRegenerateTruss({
                  ...shapeDetails,
                  piggybackSettings: { ...shapeDetails.piggybackSettings, purlinThickness },
                }),
              );
            }}
            sx={{ m: 1, width: '100%' }}
          />
        </Box>
      </LabeledBox>
    </>
  );
}
